import { format } from 'date-fns/format';
import { addMonths } from 'date-fns/addMonths';
import { startOfMonth } from 'date-fns/startOfMonth';
export function getPrevMonthLabel(monthCount) {
  // Months are one-indexed in CalendarCard, account for edge cases at beginning of range
  const adjustedMonthCount = monthCount > 0 ? monthCount - 1 : monthCount;
  const startOfThisMonth = startOfMonth(Date.now());
  const nextMonthToShow = addMonths(startOfThisMonth, adjustedMonthCount);
  return format(nextMonthToShow, 'MMMM yyyy');
}
export function getNextMonthLabel(monthCount, monthsToShow) {
  const startOfThisMonth = startOfMonth(Date.now());
  const nextMonthToShow = addMonths(startOfThisMonth, monthCount + monthsToShow);
  return format(nextMonthToShow, 'MMMM yyyy');
}